export const scheduleStatuses = {
  PENDING: 'pending',
  CURRENT: 'current',
  EXPIRED: 'expired',
  INVALID: 'invalid',
}

interface Schedule extends App.OfferSchedule {
  checkIn?: string
}

function getScheduleStatus(schedule: Schedule) {
  const now = schedule.checkIn ? new Date(schedule.checkIn) : new Date()
  const start = new Date(schedule.start)
  const end = new Date(schedule.end)

  if (now < start) {
    return scheduleStatuses.PENDING
  }
  else if (now > end) {
    return scheduleStatuses.EXPIRED
  }
  else {
    return scheduleStatuses.CURRENT
  }
}

export function scheduleIsCurrent(schedule?: App.OfferSchedule) {
  return !!schedule && getScheduleStatus(schedule) === scheduleStatuses.CURRENT
}

export function hasSellableSchedule(schedules?: Array<App.ReservationSchedule>) {
  const schds = (schedules ?? []).filter(schedule => schedule.type === 'sell')
  if (schds.length > 0) {
    return schds.some(schedule => getScheduleStatus({
      start: schedule.activePeriod.from!,
      end: schedule.activePeriod.to!,
    }) === scheduleStatuses.CURRENT)
  }
  return true // sellable if no sell schedules to restrict
}

export function hasTravellableSchedules(
  schedules: Array<App.ReservationSchedule> | undefined,
  checkIn: string,
  type?: 'sell' | 'tactical',
) {
  const schds = (schedules ?? []).filter(schedule => schedule.type === (type ?? 'sell'))
  if (schds.length > 0) {
    return schds.some(schedule => getScheduleStatus({
      start: schedule.travelPeriod.from!,
      end: schedule.travelPeriod.to!,
      checkIn,
    }) === scheduleStatuses.CURRENT)
  }
  return true // travellable if no travel schedules to restrict
}
